import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTAG_ID = process.env.REACT_APP_GTAG_ID ?? 'AW-17737958504';

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export function gtag(...args: any[]): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
  if (window.gtag) window.gtag(...args);
}

export function gtagEvent(eventName: string, params?: Record<string, any>): void {
  gtag('event', eventName, params);
}

// Conversões Google Ads — adicionar labels quando criados em Google Ads
export const gtagConversions = {
  completeRegistration(): void {
    gtag('event', 'conversion', { send_to: `${GTAG_ID}/complete_registration` });
  },
  purchase(valueCve: number, transactionId?: string): void {
    gtag('event', 'conversion', {
      send_to: `${GTAG_ID}/purchase`,
      value: valueCve,
      currency: 'CVE',
      transaction_id: transactionId,
    });
  },
};

export default function GtagLoader({ hasConsent }: { hasConsent: boolean }) {
  const location = useLocation();

  useEffect(() => {
    if (!hasConsent) return;
    if (document.getElementById('gtag-script')) return;

    // Inicializar dataLayer e gtag stub
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer!.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GTAG_ID);

    const script = document.createElement('script');
    script.id = 'gtag-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
    script.async = true;
    document.head.appendChild(script);
  }, [hasConsent]);

  // Page view em cada navegação SPA
  useEffect(() => {
    if (!hasConsent || !window.gtag) return;
    window.gtag('config', GTAG_ID, { page_path: location.pathname });
  }, [location.pathname, hasConsent]);

  return null;
}
